import DarkThemeIcon from "@client/icons/DarkThemeIcon";
import { useTheme } from "@client/utils/useTheme";
import { useRef } from "react";
import { ClickPopper } from "./ClickPopper";

export function ThemeSelector() {
  const { themePreference, setThemePreference } = useTheme();
  const btnRef = useRef<HTMLButtonElement>(null);

  const options: { value: typeof themePreference; label: string }[] = [
    { value: "system", label: "System" },
    { value: "light", label: "Light" },
    { value: "dark", label: "Dark" },
  ];

  return (
    <ClickPopper
      className="flex"
      title={
        <div className="flex flex-col w-32">
          {options.map((opt) => (
            <button
              key={opt.value}
              className="flex items-center justify-between px-2 py-1 hover:bg-stone-200 dark:hover:bg-stone-700"
              onClick={() => {
                if (!btnRef.current) return;
                const { left, top, width, height } =
                  btnRef.current.getBoundingClientRect();
                const centerX = left + width / 2;
                const centerY = top + height / 2;
                document.documentElement.style.setProperty(
                  "--ripple-x",
                  centerX + "px",
                );
                document.documentElement.style.setProperty(
                  "--ripple-y",
                  centerY + "px",
                );
                setThemePreference(opt.value);
              }}
            >
              <span>{opt.label}</span>
              {themePreference === opt.value && <span>✓</span>}
            </button>
          ))}
        </div>
      }
    >
      <button
        ref={btnRef}
        className="cursor-pointer p-2 hover:bg-stone-300 dark:hover:bg-stone-700 rounded-full flex items-center justify-center"
        title={`Theme: ${themePreference}`}
        aria-label={`Theme: ${themePreference}`}
        type="button"
      >
        <DarkThemeIcon className="fill-stone-700 dark:fill-white w-6 h-6" />
      </button>
    </ClickPopper>
  );
}

export default ThemeSelector;
